/* Empty state for the File destination.
 *
 * The Figma pins this at 328x400 inside a 360x1156 frame, leaving ~440px of
 * undefined space beneath it. Sized to fill its share of the column instead —
 * a fixed 400px box would float in the middle of a side panel of any other
 * height. */

.zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-16);
  width: 100%;
  /* Fills the destination but never collapses below a comfortable target. */
  flex: 1;
  min-height: 160px;
  padding: var(--spacing-24);
  border: 1px dashed var(--stroke-neutral);
  border-radius: var(--radius-16);
  background: var(--bg-secondary);
  cursor: pointer;
  /* Inherit rather than reset: this is a <button>, which otherwise takes the
   * UA's centred 13px system font. */
  font: inherit;
  color: inherit;
  text-align: center;
  transition: border-color 150ms ease-out, background 150ms ease-out;
}

.zone:hover:not(:disabled),
.dragging {
  border-color: var(--transfer-accent);
  background: var(--bg-tertiary);
}

.zone:focus-visible {
  outline: 2px solid var(--transfer-accent);
  outline-offset: 2px;
}

.zone:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* The zone's own children must not receive pointer events: `dragleave` fires
 * on the button whenever the pointer crosses onto a child, and these sit dead
 * centre where people drag to — the highlight would flicker off and back on
 * every pass. jsdom cannot see this. */
.glyph,
.text {
  pointer-events: none;
}

.glyph {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-circle);
  background: var(--bg-tertiary);
}

.icon {
  width: 24px;
  height: 24px;
  color: var(--text-secondary);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.title {
  font: var(--text-body-medium);
  color: var(--text-primary);
}

.limit {
  font: var(--text-micro-regular);
  color: var(--text-tertiary);
}

/* The real <input type="file">. Visually hidden but still clickable via the
 * ref; `display: none` would break `.click()` in some engines. */
.input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

@media (prefers-reduced-motion: reduce) {
  .zone {
    transition: none;
  }
}
